<template>
    <section class="top-menu">
        <div class="">
            <nav class="nav">
                <div class="nav-left">
                    <input type="button" class="sidebar-logout" @click="logout" :value="$st('sign_out')" />
                    <h1 class="title">{{$st('top_menu_title')}}</h1>
                    <h1 class="title_s">{{$st('top_menu_title_s')}}</h1>
                </div>
            </nav>
        </div>
    </section>
</template>

<script>

export default {
  components: {
  },
  created () {
  },
  computed: {
  },
  methods: {
    logout () {
      if (process.env.NODE_ENV === 'production') {
        location.href = `/?lang=${this.$store.getters['loginInfo/lang']}&type=logout`;
      } else {
        location.href = `/3012/?lang=${this.$store.getters['loginInfo/lang']}&type=logout`;
      }
    },
  },
};
</script>

<style lang="scss">
.top-menu {
  width: 100%;
  height: 47px;
  background-color: #fefefe;
  color: #333;
  box-shadow: 0px 2px 6px #c0c0c0;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 20;
  text-align: left;

  h1.title {
    font-size: 18px;
    margin: 1px 0px 0px 10px;
    display: inline-block;
    line-height: 2.7;
    color: #24273b;
    background-image: url('../../assets/logo.svg');
    background-repeat: no-repeat;
    padding-left: 120px;
    background-position-y: 11px;
    font-weight: normal;
  }

  h1.title_s {
    font-size: 18px;
    margin: 1px 0px 0px 10px;
    display: none;
    line-height: 2.7;
    color: #24273b;
    background-image: url('../../assets/logo.svg');
    background-repeat: no-repeat;
    padding-left: 120px;
    background-position-y: 11px;
    height: 48px;
  }

  .sidebar-logout {
    color: #fefefe;
    display: inline-block;
    text-align: center;
    padding: 5px;
    width: 108px;
    font-size: 16px;
    margin: 6px 6px 0px 0px;
    text-decoration: none;
    border-radius: 3px;
    float: right;
    line-height: 1.5;
  }
  .sidebar-logout:hover {
    color: #fbfbfb;
  }
  @media (max-width: 767px) {
  }
  @media (max-width: 360px) {
    h1.title {
      display: none;
    }
    h1.title_s {
      display: inline-block;
    }
  }
}
</style>
